import { motion } from "framer-motion";
import { Star, Quote, BadgeCheck, ExternalLink, PenLine } from "lucide-react";
import { TESTIMONIALS, COMPANY } from "@/data/content";

export default function Testimonials() {
  return (
    <section id="reviews" className="py-24 bg-obsidian honeycomb-bg">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-honey font-bold mb-3">From the Hive</p>
          <h2 className="text-4xl sm:text-5xl font-display font-black uppercase tracking-tighter text-white">
            Top-Rated by Snohomish County Homeowners
          </h2>
          <div className="flex items-center gap-2 mt-4">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-honey text-honey" />)}</div>
            <span className="text-zinc-300 font-semibold">Rated 5.0 on Google &amp; Angi</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div key={t.name}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.08, duration: 0.5 }}
              data-testid={`testimonial-${i}`}
              className="p-6 rounded-md border border-white/10 bg-carbon flex flex-col">
              <Quote className="w-7 h-7 text-honey/40" />
              <p className="text-sm text-zinc-300 mt-3 leading-relaxed flex-1">"{t.text}"</p>
              <div className="flex mt-4">{[...Array(t.rating)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-honey text-honey" />)}</div>
              <div className="mt-3 pt-3 border-t border-white/10">
                <p className="text-sm font-bold text-white">{t.name}</p>
                <p className="text-xs text-zinc-500 flex items-center gap-1"><BadgeCheck className="w-3.5 h-3.5 text-honey" /> {t.city}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={COMPANY.googleReviewUrl} target="_blank" rel="noopener noreferrer" data-testid="leave-review-btn"
            className="inline-flex items-center gap-2 bg-honey text-white font-bold px-6 py-3.5 rounded-sm hover:bg-honey-600 transition-colors">
            <PenLine className="w-4 h-4" /> Leave Us a 5★ Google Review
          </a>
          <a href={COMPANY.googleReviewUrl} target="_blank" rel="noopener noreferrer" data-testid="read-reviews-btn"
            className="inline-flex items-center gap-2 border border-white/20 text-white font-semibold px-6 py-3.5 rounded-sm hover:border-honey hover:text-honey transition-colors">
            <ExternalLink className="w-4 h-4" /> Read All Reviews
          </a>
        </div>
      </div>
    </section>
  );
}
